'use client';

import React, { useState, useEffect } from 'react';
import Footer from '@/components/layout/Footer';
import HeaderSection from '@/components/layout/HeaderSection';
import { policyGlobalApi } from '@/api';
import { PolicyGlobal } from '@/types/policyType';

export default function PolicyPage() {
  const [policyData, setPolicyData] = useState<PolicyGlobal | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Parse content that may be wrapped in {"html": "..."} format
  const parsePolicyContent = (content: string): string => {
    try {
      const parsed = JSON.parse(content);
      if (parsed && typeof parsed.html === 'string') {
        return parsed.html;
      }
    } catch {
      // Content is not JSON, return as-is
    }
    return content;
  };

  useEffect(() => {
    const fetchPolicyData = async () => {
      try {
        const response = await policyGlobalApi.get();
        if (response.success && response.data) {
          setPolicyData(response.data);
        } else {
          setError('Không thể tải dữ liệu chính sách');
        }
      } catch (err) {
        console.error('Error fetching policy data:', err);
        setError('Có lỗi xảy ra khi tải dữ liệu');
      } finally {
        setLoading(false);
      }
    };

    fetchPolicyData();
  }, []);

  if (loading) {
    return (
      <div className="">
        <HeaderSection
          title="Chính sách & Điều khoản"
          subtitle=""
          backgroundImage="/header_90ad.png"
        />
        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <div className="animate-pulse">
              <div className="text-gray-500">Đang tải dữ liệu...</div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="">
        <HeaderSection
          title="Chính sách & Điều khoản"
          subtitle=""
          backgroundImage="/header_90ad.png"
        />
        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <div className="text-red-500">{error}</div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="">
      <HeaderSection
        title="Chính sách & Điều khoản"
        subtitle=""
        backgroundImage="/header_90ad.png"
      />

      <div className="max-w-4xl mx-auto px-4 py-12">
        {policyData?.content ? (
          <div className="prose max-w-none text-gray-700 leading-relaxed [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:mt-6 [&_h1]:mb-3 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-5 [&_h2]:mb-2 [&_h3]:text-lg [&_h3]:font-medium [&_h3]:mt-4 [&_h3]:mb-2 [&_p]:mb-4 [&_ul]:list-disc [&_ul]:ml-6 [&_ul]:mb-4 [&_ol]:list-decimal [&_ol]:ml-6 [&_ol]:mb-4 [&_li]:mb-1 [&_strong]:font-semibold [&_b]:font-semibold [&_br]:block [&_br]:h-3">
            <div dangerouslySetInnerHTML={{ __html: parsePolicyContent(policyData.content) }} />
          </div>
        ) : policyData && !policyData.content ? (
          <div className="text-center py-12">
            <p className="text-gray-500">
              Chưa có thông tin chính sách và điều khoản.
            </p>
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500">
              Không thể tải thông tin chính sách.
            </p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
